import { useCallback } from 'react'
import { useRecoilState } from 'recoil'
import { ExpectedTransaction } from './Types'
import { ExecutionResponse } from '../../Adapters/IAdapter'
import { Config } from 'Config'
import { Transactions } from './Transactions'

export const useTransactions = () => {
  const [
    { transactions, expectedTransactions },
    setTransactionsState
  ] = useRecoilState(Transactions)

  const addTransaction = useCallback(
    (transaction: ExecutionResponse) => {
      setTransactionsState((state) => ({
        ...state,
        transactions: [...state.transactions, transaction]
      }))
    },
    [setTransactionsState]
  )

  const addExpectedTransaction = useCallback(
    (expectedTransaction: ExpectedTransaction) => {
      setTransactionsState((state) => ({
        ...state,
        expectedTransactions: [
          ...state.expectedTransactions,
          expectedTransaction
        ]
      }))
    },
    [setTransactionsState]
  )

  const getExpectedTransactionByHash = useCallback(
    (txHash: string) =>
      expectedTransactions.find((t) => {
        return t.transaction.hash === txHash
      }),
    [expectedTransactions]
  )

  const getExplorerLink = useCallback((txHash: string) => {
    return Config.transactionExplorer.replace('{{TRANSACTION_HASH}}', txHash)
  }, [])

  return {
    addTransaction,
    addExpectedTransaction,
    getExpectedTransactionByHash,
    getExplorerLink,
    transactions,
    expectedTransactions
  }
}
